import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import store from './store/store';
import './assets/scss/index.scss'
import './views/renewableEnergy/sys-info/sys-architecture/sys-architecture.scss'
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import VueWechatTitle from 'vue-wechat-title';
import dayjs from'dayjs'
import './filter/filters.js';
import './directive/index.js';
import './utils/rem.js'; //适配大屏的js
import axios from './axios/axios.js';
import Storages from './utils/storages.js';
import './assets/font/iconfont.js'
import './assets/font/iconfont.css'

import ElementUI from 'element-ui';
import * as echarts from 'echarts';
import common from './utils/common.js';
Vue.prototype.$common = common;
//全局注册图片编辑组件
import vImageEdit from './components/formComponents/imageEdit.vue';
Vue.component(vImageEdit.name, vImageEdit);
Vue.prototype.$axios = axios;

Vue.prototype.$echarts = echarts;
Vue.prototype.$dayjs = dayjs;
Vue.use(Vuex);
Vue.use(VueWechatTitle);
Vue.use(ElementUI, {
    size: 'small'
});
import BaseConfig from './baseConfig';
Vue.prototype.BaseConfig = BaseConfig;

//引入组织架构图
import Vue2OrgTree from 'vue-tree-color'
Vue.use(Vue2OrgTree)

Vue.config.productionTip = false
//不需要权限验证的路由地址
let noAuth = ['/auto-login', '/login'];
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    Storages.setLocalStorage('fromPath', from.path);
    Storages.setLocalStorage('toPath', to.path);
    const role = Storages.getLocalStorage('ms_username');
    store.state.userName = role;
    //根据路由配置是否展示项目树
    store.commit('showProjectTreeFun', to.meta.showProjectTree);
    // store.commit('isMultipleFun', to.meta.isMultiple);
    to.path !== '/' + BaseConfig.MAIN_INDEX_PATH &&
        (store.state.sidebarItem.meta = to.meta);
    var token = Storages.getLocalStorage('CHECKTOKEN')//to.query.token;
    console.log('role', role,to, to.path,token,23232323);
    // 判断是否进入碳公示
    if (to.path == "/carbonPublic") {
        store.dispatch('home/SYNE_SET_CARBONBOL', false)
    } else {
        // console.log(454545)
        store.dispatch('home/SYNE_SET_CARBONBOL', true)
    }
    // if (token) {
    //     Storages.setLocalStorage('CHECKTOKEN', token);
    //     store.commit("setRequestHeader", token);
    // }
    let IS_SINGLE_PRO=Storages.getLocalStorage("IS_SINGLE_PRO")
    if (!role) {
        // debugger
        if (token && to.path != '/dashboard') {
            next('/dashboard');
        } else if (!token && to.path !== '/login') {
            if(noAuth.includes(to.path)){
                next()
            }else{
                next('/login');
            }
        } else {
            next();
        }
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 验证后台返回登录状态
        if(IS_SINGLE_PRO&&to.path == '/dashboard'){
            next('/index');
        }else{
            next();
        }
    }
});

// 异步路由问题刷新
router.onError((error) => {
    const jsPattern = /Loading chunk (\S)+ failed/g
    const cssPattern = /Loading CSS chunk (\S)+ failed/g
    const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
    const targetPath = router.history.pending.fullPath
    if (isChunkLoadFailed) {
      Storages.setLocalStorage('targetPath', targetPath)
      window.location.reload()
    }
})
router.onReady(() => {
    const targetPath = Storages.getLocalStorage('targetPath')
    const tryReload = Storages.getLocalStorage('tryReload')
    if (targetPath) {
      Storages.removeLocalStorage('targetPath')
      if (!tryReload) {
        router.replace(targetPath)
        Storages.setLocalStorage('tryReload', true)
      } else {
        Storages.removeLocalStorage('tryReload')
      }
    }
})

// 路由跳转后的钩子
router.afterEach(function(to) {
    //5s内没响应，自动隐藏loading
    setTimeout(() => {
      store.commit('updateIsLoadingStatus', {
        isLoading: false,
      });
    }, 5000);
  });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
